import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableAfterPaint, type LoadableType } from '@confluence/loadable';

import { TableOfContentsButtonPlaceholder } from '@confluence/floating-table-of-contents-common/entry-points/tableOfContentsButtonPlaceholder.ts';

import type { TableOfContentsPopupButton } from './TableOfContentsPopupButton.tsx';

export const TableOfContentsPopupButtonLoader: LoadableType<
	React.ComponentProps<typeof TableOfContentsPopupButton>
> = LoadableAfterPaint({
	loading: () =>
		fg('confluence_sidebar_buttons_initial_render') ? <TableOfContentsButtonPlaceholder /> : null,
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-TableOfContentsPopupButton" */ './TableOfContentsPopupButton.tsx'
			)
		).TableOfContentsPopupButton,
});
